import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CoreSearchData } from '../services/search.service';

@Component({
  selector: 'app-search-base-card',
  standalone: false,
  
  template: ''
})
export class SearchBaseCardComponent {

  @Input() index: number;
  @Input() data: CoreSearchData;
  @Input() openInNewPage: boolean;
  @Input() pinned: boolean = false;

  @Output() onPinItem = new EventEmitter<{item: CoreSearchData, index: number}>();
  @Output() onUnpinItem = new EventEmitter<number>();
  @Output() onCloseDialog = new EventEmitter();

  pinItem() {
    this.onPinItem.emit({item: this.data, index: this.index});
  }

  unpinItem() {
    this.onUnpinItem.emit(this.index);
  }

  closeDialog() {
    this.onCloseDialog.emit();
  }

}
